import { render, staticRenderFns } from "./ReviewStarsBig.vue?vue&type=template&id=ce28f160"
import script from "./ReviewStarsBig.vue?vue&type=script&lang=js"
export * from "./ReviewStarsBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports